import React from "react";
import { Box, Button, Card, CardContent, Typography, Alert, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { getDefaultRoute } from "../../utils/getDefaultRoute";

const AccessDenied = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      }}
    >
      <Card elevation={1} sx={{ maxWidth: 420, width: "100%" }}>
        <CardContent>
          <Alert severity="error" sx={{ mb: 2 }}>
            Access Denied
          </Alert>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            You don’t have permission to view this page.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
            <Button variant="outlined" onClick={() => navigate(-1)}>
              Go back
            </Button>
            {user && (
              <Button variant="contained" onClick={() => navigate(getDefaultRoute(user.role, user), { replace: true })}>
                Go to your home
              </Button>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AccessDenied;
